module.exports = __webpack_public_path__ + "img/atlas_bj.88877949.png";